
const digest = '828462067b1a08b80d56fc063bc54dfb77a975c169929ca12dc3f4b3665862f0';
const classes = {"logoutButton":"_logoutButton_1ulpq_1"};
const css = `._logoutButton_1ulpq_1 {
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  